@if (picture) {
    <sew-picture
        [src]="picture.src.mq3"
        [alt]="picture.alt"
        [imgTitle]="picture.title"
        [caption]="noCaption ? null : picture.text"
    >
        @if (picture.src.mq1 && picture.src.mq1r) {
            <source
                media="(max-width:960px)"
                [attr.srcset]="picture.src.mq1 + ' 1x, ' + picture.src.mq1r + ' 2x'"
            />
        }
        @if (picture.src.mq2 && picture.src.mq2r) {
            <source
                media="(min-width:961px) and (max-width:1344px)"
                [attr.srcset]="picture.src.mq2 + ' 1x, ' + picture.src.mq2r + ' 2x'"
            />
        }
        @if (picture.src.mq3 && picture.src.mq3r) {
            <source
                media="(min-width:1345px)"
                [attr.srcset]="picture.src.mq3 + ' 1x, ' + picture.src.mq3r + ' 2x'"
            />
        }
    </sew-picture>
}
